import React from "react";
// import TrustedPartner from "../Dispatch/TrustedPartner";
import Contact from "./Container/Contact";
import ExtraBenifits from "./Container/ExtraBenifits";
import FeatureSection from "./Container/FeatureSection";
import NewBenifits from "./Container/NewBenifits";
import MobileApplication from "./Container/MobileApplication";
import MainSection from "./Container/MainSection";
import ReCaptchaProviderWrapper from "./Container/ReCaptchaProviderWrapper";

function Home() {
  return (
    <ReCaptchaProviderWrapper>
      <MainSection />
      {/*<TrustedPartner />*/}
      <FeatureSection />
      <NewBenifits />
      <MobileApplication />
      <ExtraBenifits />
      <Contact />
    </ReCaptchaProviderWrapper>
  );
}

export default Home;
